window.addEventListener("load", function () {
    if ( document.querySelectorAll('.accordeon').length ) {

        const elements = document.querySelectorAll('.accordeon');

        elements.forEach(function(element) {

            const accordeonHeader = element.querySelectorAll('dt');
            const accordeonLinks = element.querySelectorAll('dd a');

            if( accordeonHeader.length ) {

                gsap.set( element.querySelectorAll('dd') , { height: 0 } );

                accordeonHeader.forEach(function(button) {
                    button.addEventListener('click', function(event) {
                        const dt = event.target.closest('dt');
                        const dd = dt.nextElementSibling;

                        if (!dt.classList.contains('js-expanded')) {
                            dt.classList.add('js-expanded');
                            gsap.set( dd,  { height: "auto" } );
                            gsap.from( dd, .2,  { height: 0, ease: Sine.easeInOut} );

                            if (typeof gtag !== 'undefined') {
                                gtag("event", "accordion", { entry_name: dt.textContent, entry_action: 'open'});
                            }
                        } else {
                            dt.classList.remove('js-expanded');
                            gsap.to( dd, .2,  { height: 0, ease: Sine.easeInOut} );

                            if (typeof gtag !== 'undefined') {
                                gtag("event", "accordion", { entry_name: dt.textContent, entry_action: 'close'});
                            }
                        }
                    });
                });
            }

            if( accordeonLinks.length ) {
                if (typeof gtag === 'undefined') return;

                [...accordeonLinks].map((link) => {
                    // Set up the listener and handler at the same time.
                    try {
                        link.addEventListener("click", function (evt) {
                            console.log("Sending menu click to GA4.");

                            let name = evt.target.innerText;
                            let url = evt.target.closest('a').getAttribute("href");

                            // DEBUG
                            //evt.preventDefault(); // Don't navigate!
                            //console.log(`Menu item clicked: ${name} ${url}`);

                            gtag("event", "accordion", {
                                file_name: name,
                                file_url: url,
                            });
                        });
                    } catch (e) {
                        console.log(
                            "Something wrong happened when setting up event handling for the menu items."
                        );
                    }
                });
            }
        });
    }
});
